export const GET_SINGLE_SELECTED_CUSTOMER_REQ = 'GET_SINGLE_SELECTED_CUSTOMER_REQ';
export const GET_SINGLE_SELECTED_CUSTOMER_SUCC = 'GET_SINGLE_SELECTED_CUSTOMER_SUCC';
export const GET_SINGLE_SELECTED_CUSTOMER_FAIL = 'GET_SINGLE_SELECTED_CUSTOMER_FAIL';